var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7010_30510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9062 3.3125H2.09375C0.880859 3.3125 -0.0625 4.30078 -0.0625 5.46875V21.2812C-0.0625 22.4941 0.880859 23.4375 2.09375 23.4375H17.9062C19.0742 23.4375 20.0625 22.4941 20.0625 21.2812V5.46875C20.0625 4.30078 19.0742 3.3125 17.9062 3.3125ZM7.125 18.4062C7.125 18.8105 6.76562 19.125 6.40625 19.125H4.96875C4.56445 19.125 4.25 18.8105 4.25 18.4062V12.6562C4.25 12.2969 4.56445 11.9375 4.96875 11.9375H6.40625C6.76562 11.9375 7.125 12.2969 7.125 12.6562V18.4062ZM11.4375 18.4062C11.4375 18.8105 11.0781 19.125 10.7188 19.125H9.28125C8.87695 19.125 8.5625 18.8105 8.5625 18.4062V8.34375C8.5625 7.98438 8.87695 7.625 9.28125 7.625H10.7188C11.0781 7.625 11.4375 7.98438 11.4375 8.34375V18.4062ZM15.75 18.4062C15.75 18.8105 15.3906 19.125 15.0312 19.125H13.5938C13.1895 19.125 12.875 18.8105 12.875 18.4062V15.5312C12.875 15.1719 13.1895 14.8125 13.5938 14.8125H15.0312C15.3906 14.8125 15.75 15.1719 15.75 15.5312V18.4062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7010_30510",
    x: -62.5625,
    y: -59.1875,
    width: 145.125,
    height: 145.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7010_30510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7010_30510",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.b29063c9.svg";
export { ForwardRef as ReactComponent };